import React, { useMemo, useCallback } from 'react';
import propTypes from 'prop-types';
import { NavLink, Link } from 'react-router-dom';
import { UiTable } from 'src/ui';
import { Button, MuiDropdown, MuiDropdownItem } from 'src/ui/mui-ui-kit';;
;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function FIsTable({ loading, fis, onDeleteFI }) {
  const onDelete = useCallback(fi => {
    return () => onDeleteFI(fi);
  }, []);
  const tableColumns = useMemo(() => [
    {
      Header: 'Name',
      accessor: 'businessName',
      Cell: row => (
        <Link
          className="edit-link"
          to={`/financial-institutions/edit/${row.original.id}`}
        >
          {row.value}
        </Link>
      ),
    },
    {
      Header: '',
      accessor: 'id',
      sortable: false,
      width: 62,
      resizable: false,
      Cell: row => (
        <MuiDropdown
          isAlign="right"
          renderTrigger={
            <Button isColor="white">
              <span className="icon">
                <FontAwesomeIcon
                  icon={['fal', 'ellipsis-v']}
                  className="has-text-grey"
                  size="lg"
                />
              </span>
            </Button>
          }
        >
            <MuiDropdownItem
              tag={NavLink}
              to={`/financial-institutions/edit/${row.value}`}
            >
              Edit
            </MuiDropdownItem>
            <MuiDropdownItem tag="a" onClick={onDelete(row.original)}>
              Archive
            </MuiDropdownItem>
        </MuiDropdown>
      ),
    },
  ]);

  return (
    <UiTable
      columns={tableColumns}
      loading={loading}
      data={fis}
      useTablePagination
      title="Financial Institution"
      emptyTo="/financial-institutions/add"
      hidePrev
      hideNext
    />
  );
}

FIsTable.propTypes = {
  loading: propTypes.bool.isRequired,
  fis: propTypes.arrayOf(propTypes.object).isRequired,
  onDeleteFI: propTypes.func.isRequired,
};
